import React, { memo, useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import Logo from "../images/logo.svg";
import personIcon from "../images/person.svg";
import * as Yup from "yup";
import {
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CircleImg from "../images/circle-pattern-1.png";
import ArrowDown from "../images/arrow-down.svg";
import Visibility from "../images/eye-icon.svg";
import VisibilityOff from "../images/eye-close.svg";

import { useFormik } from "formik";
import LockIcon from "../images/lock_icon.svg";
import refrechIcon from "../images/refresh-icon.svg";
import { useEffect } from "react";
import {
  ACCOUNT_LOCKED_PATH,
  BILLING_STATEMENT_LIST_ROUTE,
  DAILY_ENTRY_ROUTE,
  DASHBOARD_ROUTE,
  FORGOT_PASSWORD,
  SIGNUP_ROUTE,
} from "../constants/RoutePath";
import { Link, useLocation } from "react-router-dom";
import { deCryptFun, enCryptFun, encryptText } from "./comman/CustomFunction";
import { FORGET_PASSWORD_URL, IS_OLD_USER, SIGN_IN_URL } from "../constants/ApiRoute";
import { authHeader } from "./comman/MainFunction";
import API from "./comman/API";
import { useNavigate } from "react-router-dom";
import CustomLoader from "./comman/CustomLoader";
import Captcha from "./comman/Captcha";
// import CustomToast from "./comman/CustomToast";
import { userRole as roledata } from "./comman/Constant";
import EmailSchema from "./comman/validation/EmailSchema";
import CustomToast from "./comman/CustomToast";
import { useToast } from "./comman/CustomMessages";
import { rememberMe, forgetMe } from "./comman/RememberMe";
import Cookies from "js-cookie";
import captchaIcon from "../images/captcha-field-load.svg";
import { getLoggedUserDetails, getUserCheck } from "../redux/action";
import { useDispatch } from "react-redux";
import CreateNewAccountModel from "./model/CreateNewAccountModel";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Signin = () => {
  const navigate = useNavigate();
  const logoutChannel = new BroadcastChannel("logout-channel");
  const loginChannel = new BroadcastChannel("login-channel");
  const location = useLocation();
  const showToast = useToast();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = React.useState(true);
  const [checkeRemeber, setCheckRemeber] = useState(false);
  const [isOldUserCheck, setIsoldUserCheck] = useState(false);
  const [onChaptcha, setOnChaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [flag, setFlag] = useState(false);
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const captchaRef = useRef(null);
  const handleClickShowPassword = () => {
    const input = inputRef.current.querySelector("input");

    // Toggle the password visibility
    setShowPassword(!showPassword);

    // Use a requestAnimationFrame to ensure the cursor position is set after the DOM update
    requestAnimationFrame(() => {
      input.blur(); // This removes the cursor by blurring the input field
    });
  };

  const handleRemember = (e) => {
    setCheckRemeber(!checkeRemeber);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const validationSchema = Yup.object({
    email: EmailSchema.required("Email is required"),
    password: Yup.string().required("Password is required"),
    captcha: Yup.string()
      .required("Captcha is required")
      .matches(/^[^a-z]*$/, "Captcha should not contain lowercase letters"),
  });

  const {
    handleSubmit,
    handleChange,
    setValues,
    values,
    errors,
    setErrors,
    touched,
    resetForm,
    handleBlur,
    setFieldTouched,
  } = useFormik({
    initialValues: {
      email: "",
      password: "",
      captcha: "",
    },
    enableReinitialize: true,
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      captchaValidation(values);
    },
  });

  const ForgotPasswordUser = async (values) => {
    setLoading(true);
    const postData = {
      email: values.email,
      linkUrl: window.location.origin + "/changepassword/",
    };

    const config = {
      method: "PUT",
      url: IS_OLD_USER,
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
        flutterString: "",
      },
    };
    try {
      const response = await API(config);
      console.log(response, 'responseeeeeeeeeeeee', config)
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        setIsoldUserCheck(true);
        if (captchaRef.current) {
          captchaRef.current.captchaReload();
        }
        document.getElementById("user_captcha_input").value = "";
        setCaptchaInput("");
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if(v.message == 'The user either does not exist or is not confirmed.'){
          showToast(v.message, 'error')
          if (captchaRef.current) {
            captchaRef.current.captchaReload();
          }
          setIsoldUserCheck(false);
        }else{
          setIsoldUserCheck(false);
          LoginValidation(values);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () =>{
    setIsoldUserCheck(false)
  }

  const LoginValidation = async (values) => {
    setLoading(true);
    try {
      if (checkeRemeber) {
        rememberMe({
          EMAIL: enCryptFun(values.email),
          PASSWORD: enCryptFun(values.password),
        });
      } else {
        forgetMe();
      }

      const postData = {
        email: values.email,
        password: values.password,
      };
      const config = {
        method: "POST",
        url: SIGN_IN_URL,
        data: {
          webString: enCryptFun(JSON.stringify(postData)),
          flutterString: "",
        },
      };

      const response = await API(config);
      const { accesstoken } = response.headers;
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status === "Success") {
        showToast("Signin successful", "success");
        localStorage.setItem("isLoggedIn", "true");

        const {
          UserRole,
          UserId,
          UserName,
          Email,
          HamburgerMenu,
          FirstName,
          LastName,
        } = parsedResponse.data;

        localStorage.setItem("AUTH_TOKEN", accesstoken);
        localStorage.setItem("LOG_SIDE_INDEX", "0");

        if (UserRole) {
          const selectedRoles = roledata
            .filter((role) => UserRole.includes(role.id))
            .map((role) => role.role);

          // let roleen = enCryptFun(JSON.stringify(selectedRoles));
          // localStorage.setItem("ROLE", roleen);
          localStorage.setItem(
            "ROLE",
            enCryptFun(JSON.stringify(selectedRoles))
          );

          if (
            selectedRoles.includes("Broker") &&
            !selectedRoles.includes("Admin")
          ) {
             navigate(DAILY_ENTRY_ROUTE);
            // navigate(BILLING_STATEMENT_LIST_ROUTE);
          } else {
            navigate(DASHBOARD_ROUTE);
          }
        }
        loginChannel.postMessage("login");

        // Synchronize roles across tabs
        window.dispatchEvent(new Event("storage"));

        let hm = HamburgerMenu ? 1 : 0;
        localStorage.setItem("HamburgerMenu", enCryptFun(hm.toString()));
        localStorage.setItem("LOG_USER_ID", enCryptFun(UserId));
        localStorage.setItem("LOG_USER_NAME", enCryptFun(UserName));
        localStorage.setItem("LOG_USER_EMAIL", enCryptFun(Email));
        localStorage.setItem("LOG_USER_ROLE", enCryptFun(UserRole));

        setFlag(true);
        const roles = getLogUserRole();
        // Optionally, dispatch actions or further navigation logic here.
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (
          v.message ===
          "Invalid login attempt. This account has been locked out due to excessive failed login attempts. Please contact a HOS Resources manager for more information."
        ) {
          navigate(ACCOUNT_LOCKED_PATH);
        } else {
          showToast(v.message, "error");
        }
        if (captchaRef.current) {
          captchaRef.current.captchaReload();
        }
        document.getElementById("user_captcha_input").value = "";
      }
    } finally {
      setLoading(false);
      setCaptchaInput("");
    }
  };

  const captchaValidation = async (values) => {
    if (onChaptcha === values.captcha) {
      ForgotPasswordUser(values);
      // resetForm();
    } else {
      //setErrors({ ...errors, captcha: "Enter valid captcha" });

      if (captchaRef.current) {
        captchaRef.current.captchaReload();
      }
      // setErrors({ ...errors, captcha: "Enter valid captcha" });
      showToast(
        "Invalid captcha validation. To ensure this is a legitmate request and not one initiated by an automated script (aka 'Bot'), please enter the text in the image exactly as it appears. If you cannot read the text in the image then you can click the refresh button to receive a new image.",
        "error"
      );
      setValues((prevValues) => ({
        ...prevValues,
        captcha: "",
      }));
      document.getElementById("user_captcha_input").value = "";
      setCaptchaInput("");
    }
  };

  const handleCaptchaChange = (newCaptcha) => {
    setOnChaptcha(newCaptcha);
  };

  useEffect(() => {
    const rememberedUser = Cookies.get("LoginDetail");
    if (rememberedUser) {
      let rememberedUserData = JSON.parse(rememberedUser);
      if (
        rememberedUserData &&
        rememberedUserData.EMAIL &&
        rememberedUserData.PASSWORD
      ) {
        setValues({
          email: deCryptFun(rememberedUserData.EMAIL),
          password: deCryptFun(rememberedUserData.PASSWORD),
          captcha: "",
        });
        setCheckRemeber(true);
      }
    }
  }, []);
  // const handleBlurcall=()=>{
  //   console.log('i m blured')
  // }

  useEffect(() => {
    // Push a dummy state to history stack to prevent back navigation
    window.history.pushState(null, null, window.location.pathname);

    const handlePopState = (event) => {
      // Prevent the back button and navigate to the sign-in page
      navigate("/signin", { replace: true });
    };

    // Listen for popstate event
    window.addEventListener("popstate", handlePopState);

    return () => {
      // Clean up the event listener
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);
  const [expanded, setExpanded] = React.useState(false);

  const handleChanges = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Grid container rowSpacing={1}>
          <Grid sx={{ p: "0 !important" }} item xs={12} md={6} lg={6}>
            <Box
              sx={{
                height: { xs: "auto", md: "100vh" },
                minHeight: { xs: "auto", md: "90%" },
                padding: { xs: "40px", md: "40px 59px" },
                paddingRight: { xs: "40px", md: "68px" },
                paddingTop: "46px",
              }}
              className="welcome-box"
            >
              {flag && (
                <CustomToast open={flag} message="sign in successfull" />
              )}
              {/* <Box className="login-bg-color login-bg-top"></Box> */}
              <img className="logo" src={Logo} />
              <h1 className="login-title">
                Welcome to
                <br /> <span className="smart-billing">
                  Smart Billing
                </span> by <br />
                HOS Resources
              </h1>
              <p className="login-text">
                Smart Billing is the billing solution that enables HOS Resources
                to quickly collect, consolidate, and invoice billing statements
                from brokers in the field.
              </p>
              {/* <Box className="login-bg-color login-bg-bottom"></Box> */}
              <Accordion
                className="login-accord"
                expanded={expanded === "panel1"}
                onChange={handleChanges("panel1")}
              >
                <AccordionSummary
                  expandIcon={<img src={ArrowDown} />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  About
                </AccordionSummary>
                <AccordionDetails>
                  HOS Resources, LLC (“HOS”) is a Lafayette, Louisiana based
                  energy consulting firm formed in 2015. HOS retains independent
                  contractor landmen to provide our clients with quality land
                  services throughout the country. These include title,
                  abstracting, curative, leasing, right-of-way acquisitions,
                  land acquisition, and any other services required to meet our
                  clients’ needs.
                </AccordionDetails>
              </Accordion>
              <Accordion
                className="login-accord"
                expanded={expanded === "panel2"}
                onChange={handleChanges("panel2")}
              >
                <AccordionSummary
                  expandIcon={<img src={ArrowDown} />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  Leadership & Experience
                </AccordionSummary>
                <AccordionDetails>
                  HOS’s founders combine for over 34 years of industry
                  experience in negotiating and acquiring oil and gas leases,
                  right-of-ways, seismic permits and options, as well as surface
                  leases throughout the country, including Louisiana,
                  Mississippi, Alabama, Texas, Utah, Minnesota, New York and
                  Illinois. They have represented oil and gas exploration
                  companies, midstream pipeline and storage companies, renewable
                  energy developers, law firms, large landowners, working
                  interest participants, private equity funds, and banks. HOS’s
                  senior landmen have over 50 years combined industry
                  experience.
                </AccordionDetails>
              </Accordion>
            </Box>
          </Grid>
          <Grid sx={{ background: "#fff" }} item xs={12} md={6} lg={6}>
            <Box className="form-box login">
              <Typography className="form-title" variant="h2">
                Lets get started!
              </Typography>
              <p className="form-text">Use the form below to log in.</p>
              <Box component={"form"} onSubmit={handleSubmit}>
                <FormControl variant="standard">
                  <p className="label">Email</p>
                  <Input
                    name="email"
                    id="email"
                    value={values.email}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      const newValue = e.target.value.replace(/\s/g, ""); // Remove all spaces
                      handleChange({
                        target: {
                          name: "email",
                          value: newValue,
                        },
                      });
                      if (touched.email) {
                        setFieldTouched("email", false);
                      }
                    }}
                    placeholder="Enter username"
                    startAdornment={
                      <InputAdornment position="start">
                        <img src={personIcon} />
                      </InputAdornment>
                    }
                    error={errors.email && touched.email}
                    helperText={
                      errors.email && touched.email ? errors.email : ""
                    }
                  />
                  <FormHelperText error={true}>
                    {errors.email && touched.email ? errors.email : ""}
                  </FormHelperText>
                </FormControl>
                <FormControl variant="standard">
                  <p className="label">Password</p>
                  <Input
                    name="password"
                    id="password"
                    ref={inputRef}
                    onChange={(e) => {
                      handleChange(e);
                      if (touched.password) {
                        setFieldTouched("password", false);
                      }
                    }}
                    onBlur={handleBlur}
                    placeholder="Enter your password"
                    type={!showPassword ? "text" : "password"}
                    startAdornment={
                      <InputAdornment position="start">
                        <img src={LockIcon} />
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? (
                            <img src={VisibilityOff} />
                          ) : (
                            <img src={Visibility} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    value={values.password}
                    error={errors.password && touched.password}
                    helperText={
                      errors.password && touched.password ? errors.password : ""
                    }
                  />
                  <FormHelperText
                    error={true}
                    style={{ marginLeft: "0px !important" }}
                  >
                    {errors.password && touched.password ? errors.password : ""}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  sx={{ ".form-box.login &": { mb: "5px !important" } }}
                  variant="standard"
                >
                  <p className="label">Are you human?</p>
                  <OutlinedInput
                    name="captcha"
                    // id="captcha"
                    placeholder="Enter the captcha below"
                    id="user_captcha_input"
                    type="text"
                    // value={values.captcha}
                    onChange={(e) => {
                      const uppercaseValue = e.target.value.toUpperCase();
                      setCaptchaInput(e.target.value);
                      setValues((prevValues) => ({
                        ...prevValues,
                        captcha: e.target.value.toUpperCase(),
                      }));
                      handleChange({
                        ...e,
                        target: {
                          ...e.target,
                          value: uppercaseValue,
                        },
                      });
                      if (touched.captcha) {
                        setFieldTouched("captcha", false);
                      }
                    }}
                    // onBlur={captchaValidation}
                    error={errors.captcha && touched.captcha}
                    helperText={
                      errors.captcha && touched.captcha ? errors.captcha : ""
                    }
                    startAdornment={
                      <InputAdornment position="start" sx={{ mr: "10px" }}>
                        <img src={captchaIcon} />
                      </InputAdornment>
                    }
                    inputProps={{
                      style: {
                        textTransform: captchaInput ? "uppercase" : "none", // Apply uppercase only if necessary
                      },
                    }}
                  />

                  <FormHelperText error={true}>
                    {errors.captcha && touched.captcha ? errors.captcha : ""}
                  </FormHelperText>

                  {/* <Input
                    id="input-with-icon-adornment"
                    startAdornment={
                      <InputAdornment position="start">
                        <img src={refrechIcon} />
                      </InputAdornment>
                    }
                  /> */}
                </FormControl>
                <Captcha
                  ref={captchaRef}
                  onChangeCaptcha={handleCaptchaChange}
                />

                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  spacing={2}
                  sx={{ mb: "-3px" }}
                >
                  <Box>
                    <FormControlLabel
                      className="checkbox"
                      control={
                        <Checkbox
                          sx={{ color: "gray" }}
                          value={checkeRemeber}
                          checked={checkeRemeber ? true : false}
                          onClick={handleRemember}
                        />
                      }
                      label="Remember me"
                    />
                  </Box>
                  <Link className="link" to={FORGOT_PASSWORD} underline="none">
                    {"Forgot Password?"}
                  </Link>
                </Stack>
                <Button
                  sx={{ marginTop: "16px !important" }}
                  className="login-btn"
                  variant="contained"
                  size="large"
                  type="submit"
                  disabled={loading}
                >
                  {loading && <CustomLoader loading={loading} />}
                  Login
                </Button>
                <p className="account">
                  Don’t have an account?&nbsp;
                  <Link className="link" to={SIGNUP_ROUTE} underline="none">
                    Create an account
                  </Link>
                </p>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      {isOldUserCheck && (
        <CreateNewAccountModel
          open={isOldUserCheck}
          handleClose={handleClose}
          message={
            "For your account's safety, we require you to update your password. Please check your email for instructions to reset your password. This ensures your information remains protected."
          }
          isOlderUserChecking = {'IS_OLD_USER'}
          setIsoldUserCheck = {setIsoldUserCheck}
        />
      )}
    </>
  );
};

export default Signin;
